module.exports = __webpack_public_path__ + "static/media/btn-alipay.3eeb07f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn-alipay.svg
// module id = 178
// module chunks = 0